import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-light-svg-icons';
import { Button } from 'antd';

function Header({ goBack }) {
  return (
    <div className="map-external-constituent-header">
      <Button onClick={goBack} className="link-btn" type="link">
        <FontAwesomeIcon className="arc-color-primary arc-cursor-p" icon={faArrowLeft} />
        <span className="arc-color-primary arc-cursor-p arc-p ml8">Go Back</span>
      </Button>
    </div>
  );
}

export default Header;
